import { useEffect, useState, useMemo, useCallback } from 'react';
import { APPLICATIONS_GROUPS, ESPANOL, READING } from '../../constants/applications';
import { getURLQueryParams, updateURLQueryParams } from '../navigation/navigation';

const getDefaultGroup = licensedAppGroups => {
    const { groupName: urlGroupName } = getURLQueryParams();
    if (licensedAppGroups.includes(urlGroupName)) {
        return urlGroupName;
    }
    if (licensedAppGroups.includes(READING)) {
        return READING;
    }
    if (licensedAppGroups.includes(ESPANOL)) {
        return ESPANOL;
    }
    return null;
};

const getLicensedAppGroups = applications => {
    const licensedApplications = Object.keys(applications);
    return Object.keys(APPLICATIONS_GROUPS).filter(groupName =>
        APPLICATIONS_GROUPS[groupName].some(app => licensedApplications.includes(app)),
    );
};

const useAppGroup = applications => {
    const licensedAppGroups = useMemo(() => getLicensedAppGroups(applications), [applications]);

    const [appGroup, setAppGroup] = useState(() => getDefaultGroup(licensedAppGroups));

    const setLicensedAppGroup = useCallback(
        group => {
            if (licensedAppGroups.includes(group)) {
                setAppGroup(group);
            }
        },
        [licensedAppGroups],
    );

    useEffect(() => {
        updateURLQueryParams({ groupName: appGroup });
    }, [appGroup]);

    return {
        appGroup,
        setAppGroup: setLicensedAppGroup,
    };
};

export default useAppGroup;
